import axios from 'axios'
import qs from 'qs'

function commApiRequest(baseURL) {
    
    const api = axios.create({
        baseURL: baseURL || process.env.VUE_APP_API_LIVE_USER,
        timeout: 10000,
        withCredentials: false
    })
    
    api.interceptors.request.use(
        config => {
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
            config.data = qs.stringify({
                token: localStorage.getItem('token'),
                ...config.data
            })
            return config
        },
        err => {
            return Promise.reject(err).catch(err => console.log(err))
        }
      )
      
      // Add a response interceptor
      api.interceptors.response.use(
        response => {
            // Do something with response data
        if (response.data.code === 100067 || response.data.code === 100068) {
            // 清除本地token
            localStorage.removeItem('token')
            // 重新加载页面
            // location.reload()
        }
            return response
        },
        error => {
            // Do something with response error
            return Promise.reject(error).catch(err => console.log(err))
        }
      )

      return api
}

export default commApiRequest
